import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CookieConsent } from "./CookieConsent";
import { TooltipProvider } from "./ui/tooltip";

export function Layout() {
  const location = useLocation();

  return (
    <TooltipProvider delayDuration={200}>
      <div className="relative flex min-h-dvh flex-col bg-background overflow-x-hidden">
        {/* Ambient gradient orbs */}
        <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden>
          <div
            className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full animate-orb-1 opacity-30 dark:opacity-20"
            style={{
              background: "radial-gradient(circle, hsl(var(--primary) / 0.15) 0%, transparent 70%)",
            }}
          />
          <div
            className="absolute -bottom-[10%] -right-[10%] h-[500px] w-[500px] rounded-full animate-orb-2 opacity-25 dark:opacity-15"
            style={{
              background: "radial-gradient(circle, hsl(var(--accent) / 0.12) 0%, transparent 70%)",
            }}
          />
          <div
            className="absolute top-[40%] left-[60%] h-[400px] w-[400px] rounded-full animate-orb-1 opacity-20 dark:opacity-10"
            style={{
              background: "radial-gradient(circle, hsl(var(--success) / 0.1) 0%, transparent 70%)",
              animationDelay: "-7s",
            }}
          />
        </div>

        {/* Subtle noise texture */}
        <div className="pointer-events-none fixed inset-0 z-[1]" aria-hidden>
          <svg width="0" height="0">
            <filter id="noise">
              <feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" />
              <feColorMatrix type="saturate" values="0" />
              <feComponentTransfer>
                <feFuncA type="linear" slope="0.018" />
              </feComponentTransfer>
            </filter>
          </svg>
          <div className="absolute inset-0 opacity-40 dark:opacity-50" style={{ filter: "url(#noise)" }} />
        </div>

        <div className="relative z-10 flex min-h-dvh flex-col">
          <Header />
          <AnimatePresence mode="wait">
            <motion.main
              key={location.pathname}
              id="main"
              className="flex-1"
              initial={{ opacity: 0, y: 10, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -6, filter: "blur(2px)" }}
              transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className="container py-8 md:py-10">
                <Outlet />
              </div>
            </motion.main>
          </AnimatePresence>
          <Footer />
          <CookieConsent />
        </div>
      </div>
    </TooltipProvider>
  );
}
